export default class SignatureFlavors {
  constructor() {
    console.info('SignatureFlavors.constructor()');

    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    tag.className = 'optanon-category-C0004';

    const rellax = new Rellax('.rellax', {
      center: true,
    });

    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    this.initListeners();
  }

  initListeners() {
    console.info('SignatureFlavors.initListeners()');

    const playVideo = (e) => {
      e.preventDefault();

      const youtubeID = $(e.currentTarget).data('video');
      const playerID = $(e.currentTarget).data('player');
      $(e.currentTarget).hide();

      this.onYouTubeIframeAPIReady(youtubeID, playerID);
    };

    $('.js-play-video').on('click', playVideo);

    $('.js-play-video').on('keydown', (e) => {
      if (e.keyCode == 13 || e.keyCode == 32) {
        playVideo(e);
      }
    });

    $('#content-nav a')
      .off('click')
      .on('click', (e) => {
        if (e.currentTarget.hash !== '') {
          e.preventDefault();
          let hash = e.currentTarget.hash;
          let offset = $(hash).offset().top;

          $('html, body').animate(
            {
              scrollTop: offset,
            },
            500
          );
        }
      });

    $('.signature-flavors-modal .nav-item--type button').click((e) => {
      e.preventDefault();
      const $el = $(e.currentTarget);
      const type = $el.attr('data-type');
      $('.signature-flavors-modal .type__content').hide();
      $(`.signature-flavors-modal .type__content[data-type=${type}]`).show();
      $('.signature-flavors-modal .nav-item--type button').removeClass('active');
      $el.addClass('active');
    });
  }

  onYouTubeIframeAPIReady(youtubeID, playerID) {
    const player = new YT.Player(playerID, {
      height: '390',
      width: '640',
      videoId: youtubeID,
      events: {
        onReady: this.onPlayerReady,
        onStateChange: this.onPlayerStateChange,
      },
    });
  }

  onPlayerReady(event) {
    event.target.playVideo();
    Electro.activity.contentView('Video Viewed');
  }

  onPlayerStateChange(event) {
    switch (event.data) {
      case 0:
        console.info('video ended');
        break;
      case 1:
        console.info('video playing');
        break;
      case 2:
        console.info('video paused');
    }
  }
}
